import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "component-group-title"
}
const _hoisted_2 = { class: "component-group__title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Cta = _resolveComponent("Cta")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["component-group", { header: $props.isHeader, footer: $props.isFooter, body: !$props.isHeader && !$props.isFooter }])
  }, [
    ($props.title || $props.ctaText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */),
          ($props.ctaText)
            ? (_openBlock(), _createBlock(_component_Cta, {
                key: 0,
                type: "link",
                size: "sm",
                label: $props.ctaText,
                route: $props.ctaRoute,
                fitInline: true,
                onUpdateRoute: $options.handleUpdateExterior
              }, null, 8 /* PROPS */, ["label", "route", "onUpdateRoute"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.components, (component, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass([$props.isHeader ? 'component-header-item' : 'component-item', { 'single-component': $props.components.length === 1 }])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(component.vueComponent), _mergeProps(component, {
          isDisabled: $options.isDisabledGroup,
          onUpdateSelection: $options.handleUpdateSelection,
          onUpdateRoute: $options.handleUpdateRoute,
          onUpdateRouteBack: $options.handleUpdateRouteBack
        }), null, 16 /* FULL_PROPS */, ["isDisabled", "onUpdateSelection", "onUpdateRoute", "onUpdateRouteBack"]))
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}